import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "personal-center-card__item--bd card-table" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"card-table__head\"><div class=\"card-table__result\">结果ID</div><div class=\"card-table__time\">提交时间</div><div class=\"card-table__user\">提交用户</div><div class=\"card-table__score\">得分</div><div class=\"card-table__type\">类型</div><div class=\"card-table__user\">状态</div></div>", 1)
const _hoisted_3 = {
  key: 0,
  class: "card-table__list card-table__list-empty"
}
const _hoisted_4 = { class: "card-table__result" }
const _hoisted_5 = { class: "card-table__time" }
const _hoisted_6 = { class: "card-table__user" }
const _hoisted_7 = { class: "card-table__score" }
const _hoisted_8 = { class: "card-table__type" }
const _hoisted_9 = { class: "card-table__reason" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" })
], -1)
const _hoisted_11 = { class: "card-table__pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popover = _resolveComponent("Popover")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.workers.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "此赛道暂无提交记录"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workers, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card-table__list",
        key: item.Id
      }, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(item.Id), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.momentTime(item.CreateTime)), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(item.UinName), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(item.Score > -1 ? item.Score : ''), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.stepMap.get(Number(_ctx.Step))) + "结果/" + _toDisplayString(_ctx.worksMap.get(item.ResultType)), 1),
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.workStatusMap.get(item.IsProcess)) + " ", 1),
          (item.IsProcess === 4)
            ? (_openBlock(), _createBlock(_component_Popover, {
                key: 0,
                placement: "bottom",
                trigger: "hover",
                content: item.Msg || '-'
              }, {
                reference: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["content"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", null, "共" + _toDisplayString(_ctx.totalPage) + "项", 1),
      _createVNode(_component_Pagination, {
        small: "",
        layout: "prev, pager, next",
        total: _ctx.totalPage,
        onCurrentChange: _ctx.changePage,
        "page-size": _ctx.pageSize
      }, null, 8, ["total", "onCurrentChange", "page-size"])
    ])
  ]))
}